export default __webpack_public_path__ + "static/media/getFetch.5fde86e3.cjs";